<template>
  <div id="workOrder" class="work-float">
    <popover
      placement="left-end"
      trigger="hover"
      width="60"
      content="我的工单"
      v-show="false"
    >
      <div
        slot="reference"
        class="work-float-item flex a-center j-center"
        @click="goWorkOrder"
      >
        <i class="el-icon-tickets"></i>
      </div>
    </popover>
    <div
      class="btn flex a-center j-center"
      @mouseenter="
        backIn = true;
        isShow = true;
      "
    >
      <img src="../assets/images/问题反馈/小按钮.png" alt="" />
    </div>
    <div
      v-show="isShow"
      class="info"
      :class="[backIn ? 'animate__backInRight' : 'animate__backOutRight']"
      @mouseleave="backIn = false"
    >
      <div class="info-title">意见反馈</div>
      <img
        class="info-img"
        src="../assets/images/问题反馈/矢量智能对象.png"
        alt=""
      />
      <div class="info-text">欢迎您留下你的宝贵意见。点击即可留言。</div>
      <div class="info-btn" @click="goWorkOrder">点击留言</div>
    </div>
  </div>
</template>

<script>
import { Popover } from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
export default {
  data() {
    return {
      backIn: false,
      isShow: false,
    };
  },
  components: {
    Popover,
  },
  props: {},
  methods: {
    // 进入工单列表
    goWorkOrder() {
      window.open("https://fangzhen.autotool.com.cn/ResourceLibrary/orderList");
      // window.open("https://new.cdrcyh.com.cn/ResourceLibrary/orderList");
    },
  },
  mounted() {},
  watch: {},
  computed: {},
};
</script>

<style scoped>
#workOrder {
  position: fixed;
  right: 10px;
  width: 40px;
  min-height: 40px;
  bottom: 40px;
  z-index: 998;
}
.work-float-item {
  width: 40px;
  height: 40px;
  background: #fff;
  box-shadow: 2px 2px 15px 0 rgba(0, 0, 0, 0.2);
  border-radius: 50%;
  color: #3d3d3d;
  text-align: center;
  line-height: 42px;
  margin-top: 10px;
  transition: all 0.2s cubic-bezier(0.215, 0.61, 0.355, 1);
  position: relative;
  cursor: pointer;
}
.work-float-item:first-child {
  margin-top: 0;
}
.work-float-item > i {
  font-size: 20px;
}
.btn {
  width: 46px;
  height: 46px;
  background: #827e7c;
  border-radius: 3px;
  cursor: pointer;
  overflow: hidden;
}
.btn > img {
  width: 46px;
  height: 46px;
}
.info {
  position: absolute;
  bottom: 0;
  right: -10px;
  z-index: 2;
  width: 255px;
  height: 320px;
  box-sizing: border-box;
  background: #ffffff;
  border: 1px solid #e6e6e6;
  padding: 30px;
  /* transform: translateX(2000px); */
  opacity: 0;
  transform: translateX(2000px) scale(0.7);
  opacity: 0.7;
}
.info-title {
  font-size: 24px;
  font-weight: bold;
  color: #0a0909;
  margin-bottom: 20px;
  /* line-height: 46px; */
}
.info-img {
  display: block;
  margin: 0 auto;
  width: 104px;
  height: 92px;
}
.info-text {
  font-size: 14px;
  font-weight: 400;
  color: #262626;
  line-height: 24px;
  margin: 20px 0;
}
.info-btn {
  font-size: 14px;
  font-weight: 400;
  color: #ffffff;
  line-height: 24px;
  width: 108px;
  height: 36px;
  background: #1c69d4;
  margin: 0 auto;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}
.animate__backInRight {
  animation: backInRight 1s ease-in-out forwards;
}
@keyframes backInRight {
  0% {
    -webkit-transform: translateX(2000px) scale(0.7);
    transform: translateX(2000px) scale(0.7);
    opacity: 0.7;
  }
  80% {
    -webkit-transform: translateX(0) scale(0.7);
    transform: translateX(0) scale(0.7);
    opacity: 0.7;
  }
  to {
    -webkit-transform: scale(1);
    transform: scale(1);
    opacity: 1;
  }
}
.animate__backOutRight {
  /* -webkit-animation-name: backOutRight;
  animation-name: backOutRight; */
  animation: backOutRight 1s ease-out forwards;
}
@keyframes backOutRight {
  0% {
    -webkit-transform: scale(1);
    transform: scale(1);
    opacity: 1;
  }
  20% {
    -webkit-transform: translateX(0) scale(0.7);
    transform: translateX(0) scale(0.7);
    opacity: 0.7;
  }
  to {
    -webkit-transform: translateX(2000px) scale(0.7);
    transform: translateX(2000px) scale(0.7);
    opacity: 0.7;
  }
}
</style>